import { render } from "./DepotGroupModal.vue?vue&type=template&id=5f52f02f"
import script from "./DepotGroupModal.vue?vue&type=script&lang=js"
export * from "./DepotGroupModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__